/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Autocomplete,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { toast } from 'react-toastify';
import { DatePicker } from '@mui/x-date-pickers';
import AppConst from '../AppLayout/const';
import { getProductSamplingInventory } from '../../api/weeklyProductReportApi';
import { getTeamFilter, getRepFilter, getSpecialtyFilter } from '../../api/filterOptionsApi';
// Helper Functions
import {
  filterValue,
  filterTeamOptions,
  filterRepOptions,
  filterSpecialtyOptions,
} from '../../helpers/filterFunctions';

export default function ProductSamplingInventoryModal() {
  const { toggleModal, onToggleModal } = useContext(AppConst.AppContext);
  const [toggle, setToggle] = useState(false);

  const defaultFilter = {
    team: { label: 'ALL', value: null },
    specialty: { label: 'ALL', value: null },
    rep_id: { label: 'ALL', value: null },
    from: moment().format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
  };

  const [teamOptions, setTeamOptions] = useState([]);
  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [repOptions, setRepOptions] = useState([]);
  const [filterForm, setFilterForm] = useState(defaultFilter);

  const loadSpecialtyOptions = async () => {
    const request = {
      team: filterValue(filterForm?.team),
      rep_id: filterValue(filterForm?.rep_id),
      date_from: moment(filterForm?.from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.to).format('YYYY-MM-DD'),
    };
    const response = await getSpecialtyFilter(request);
    const { code, data } = response.data;
    if (code === '200') {
      const dropdownValue = filterSpecialtyOptions(data);
      setSpecialtyOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };
  const loadTeamOptions = async () => {
    const request = {
      team: filterValue(filterForm?.team),
      rep_id: filterValue(filterForm?.rep_id),
      specialties: filterValue(filterForm?.specialty),
      date_from: moment(filterForm?.from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.to).format('YYYY-MM-DD'),
    };
    const response = await getTeamFilter(request);
    const { code, data } = response.data;
    if (code === '200') {
      const dropdownValue = filterTeamOptions(data);
      setTeamOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };
  const loadRepOptions = async () => {
    const request = {
      team: filterValue(filterForm?.team),
      rep_id: filterValue(filterForm?.rep_id),
      specialties: filterValue(filterForm?.specialty),
      date_from: moment(filterForm?.from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.to).format('YYYY-MM-DD'),
    };
    const response = await getRepFilter(request);
    const { code, data } = response.data;
    if (code === '200') {
      const dropdownValue = filterRepOptions(data);
      setRepOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  useEffect(() => {
    if (toggleModal?.url === 'report/product_sampling_inventory') {
      setToggle(true);
      loadTeamOptions();
      loadSpecialtyOptions();
      loadRepOptions();
    }
  }, [toggleModal]);

  const handleExport = async () => {
    try {
      toast.loading('Please wait ...');
      const request = {
        department: '',
        head_id: '',
        manager_id: '',
        rep_id: filterForm?.rep_id?.value,
        keyword: '',
        from: filterForm?.from,
        to: filterForm?.to,
        specialty: filterForm?.specialty?.value ? [filterForm?.specialty?.value] : [],
        team: filterForm?.team?.value ? [filterForm?.team?.value] : [],
      };
      const res = await getProductSamplingInventory(request);

      const { code, result } = res.data.response;
      if (code === '200') {
        window.location.href = result;
        toast.success(`Successfully downloaded file: ${res?.data?.response?.file_name}`);
      }
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleChangeFrom = (value) => {
    setFilterForm({ ...filterForm, from: moment(value).format('YYYY-MM-DD') });
  };

  const handleChangeTo = (value) => {
    setFilterForm({ ...filterForm, to: moment(value).format('YYYY-MM-DD') });
  };

  const handleCancel = () => {
    onToggleModal(null);
    setToggle(false);
    setFilterForm(defaultFilter);
  };

  return (
    <Dialog open={toggle} onClose={handleCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Product Sampling Inventory</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} mb={1}>
          <Grid md={12}>
            <Autocomplete
              id='team'
              fullWidth
              options={teamOptions}
              autoComplete
              disableClearable
              value={filterForm.team}
              onChange={(event, newValue) => {
                setFilterForm({
                  ...filterForm,
                  team: newValue,
                });
              }}
              renderInput={(params) => <TextField {...params} label='Team' fullWidth />}
              size='small'
            />
          </Grid>
          <Grid md={12}>
            <Autocomplete
              id='specialty'
              fullWidth
              disableClearable
              options={specialtyOptions}
              autoComplete
              value={filterForm.specialty}
              onChange={(event, newValue) => {
                setFilterForm({
                  ...filterForm,
                  specialty: newValue,
                });
              }}
              renderInput={(params) => <TextField {...params} label='Specialty' fullWidth />}
              size='small'
            />
          </Grid>
          <Grid md={12}>
            <Autocomplete
              id='rep_id'
              fullWidth
              disableClearable
              options={repOptions}
              autoComplete
              value={filterForm.rep_id}
              onChange={(event, newValue) => {
                setFilterForm({
                  ...filterForm,
                  rep_id: newValue,
                });
              }}
              renderInput={(params) => <TextField {...params} label='MPR' fullWidth />}
              size='small'
            />
          </Grid>
          <Grid xs={6}>
            <DatePicker
              label='from'
              views={['month', 'day', 'year']}
              value={filterForm?.from}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => (
                <TextField {...params} label='From' size='small' fullWidth />
              )}
              onChange={(value) => handleChangeFrom(value)}
            />
          </Grid>
          <Grid xs={6}>
            <DatePicker
              label='to'
              views={['month', 'day', 'year']}
              value={filterForm?.to}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='To' size='small' fullWidth />}
              onChange={(value) => handleChangeTo(value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleExport}>Submit</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
